import { render, staticRenderFns } from "./ExhibitPage.vue?vue&type=template&id=3a174cf1&scoped=true"
import script from "./ExhibitPage.vue?vue&type=script&lang=js"
export * from "./ExhibitPage.vue?vue&type=script&lang=js"
import style0 from "./ExhibitPage.vue?vue&type=style&index=0&id=3a174cf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a174cf1",
  null
  
)

export default component.exports